import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p>© {new Date().getFullYear()} JNTU-GV | Certification Course</p>
    </footer>
  );
}

